import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/home';

export default function HotComicsSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-foreground-950 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-8 mb-8 md:mb-10">
          <span className="inline-flex items-center self-start px-4 py-1.5 rounded-full border border-background-50/25 text-background-50 text-xs font-medium whitespace-nowrap">
            {t('home:section_hot_tag')}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
            {t('home:section_hot_title')}
          </h2>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-6 md:px-6 scrollbar-hide">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex-shrink-0 w-[200px] md:w-[220px] bg-secondary-500 rounded-2xl overflow-hidden cursor-pointer group"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - ${comic.author}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="px-3 md:px-4 py-3 md:py-4 bg-foreground-950">
                <h3 className="text-sm md:text-base font-semibold text-background-50 truncate">{comic.title}</h3>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="text-xs text-foreground-400">{comic.author}</span>
                  <span className="text-xs text-accent-400">{comic.views}{t('home:comic_views')}</span>
                </div>
              </div>
            </Link>
          ))}
          <div className="flex-shrink-0 w-8 md:w-12"></div>
        </div>
      </div>
    </section>
  );
}